// const NEW_MT4_URL_BV = 'http://crm.fxbv.co.nz/Regist/RegistUser'
// API_URL = '' // 正式
// API_URL = 'http://49.234.231.151:8093/' // 测试
// API_URL = 'http://129.211.107.236/' // 临时
// API_URL = 'http://47.56.88.121:9977/' // 测试
API_URL = 'https://api.ecmarkets.co.uk/' // 正式




 _WEB_LANG_ = (navigator.language || navigator.browserLanguage).toLowerCase()
_DEFAULT_LANGUAGE_ = _WEB_LANG_.indexOf('zh') >= 0 ? 'zh' : 'en'
// _ORIGIN_URL_ = 'http://49.234.231.151:8086/'
// _API_URL_ = _ORIGIN_URL_ + '/'
_SHOW_LOADING_ = null
_HIDE_LOADING_ = null
_PUBLIC_KEY_ = ''



RSA_PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEN0fhvEUjq8xoh4E7utJc/Drm2ZUoQNM/BGYBgkWBnlSOYdvs/5C5nUcwqQiC5tEFnqDoEYvUqPL5kZf6sL21SOlQKIFuPCcq14XgWatg5fSy3Gq2YZ2IUN+ARxPrdPVcAZTRdJCoOhSTED8lqLOOabZd0orai33wbM+NW0BVWQIDAQAB'
isMaintain = false//是否维护提示变量

// export default {
//   RSA_PUBLIC_KEY,
//   _DEFAULT_LANGUAGE_,
// //   NEW_MT4_URL_BV,
//   API_URL,
//   isMaintain
// }
